import { clearStorage } from "./storage";

type NavigateFn = (path: string) => void;

const ADMIN_LOGIN_PATH = "/admin/login";
const TENANT_LOGIN_PATH = "/app/login";

export const logoutAndRedirect = ({
  isAdmin = false,
  navigate,
}: {
  isAdmin?: boolean;
  navigate?: NavigateFn;
} = {}) => {
  clearStorage();

  const targetPath = isAdmin ? ADMIN_LOGIN_PATH : TENANT_LOGIN_PATH;
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : "";

  if (navigate) {
    navigate(targetPath);
    return;
  }

  if (typeof window !== "undefined" && !currentPath.startsWith(targetPath)) {
    window.location.assign(targetPath);
  }
};
